import type React from 'react'
import {
  AccountsPanel,
  BankingPanel,
  SalesPanel,
  TimeBillingPanel,
  PurchasesPanel,
  InventoryPanel,
  CardFilePanel,
} from './panels'

// Panel registry - maps tab IDs to panel components
export const PANEL_COMPONENTS: Record<string, React.ComponentType> = {
  accounts: AccountsPanel,
  banking: BankingPanel,
  sales: SalesPanel,
  'time-billing': TimeBillingPanel,
  purchases: PurchasesPanel,
  inventory: InventoryPanel,
  'card-file': CardFilePanel,
}
